<template>
  <div class="headline seasidetms_color_scheme_default">
    <div class="headline_outer seasidetms_headline_disabled">
      <div class="headline_color"></div>
      <div :class="`headline_inner align_left${headlineExtraClass}`">
        <div class="headline_inner_border">
          <div class="headline_aligner"></div>
          <div class="headline_text_wrap">
            <template v-if="$mq.xtablet"><Breadcrumbs /></template>
            <Headline v-if="!isHide" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/header/Breadcrumbs'
import Headline from '@/components/header/Headline'

export default {
  name: 'HeadlineHeader',
  components: { Headline, Breadcrumbs },
  computed: {
    isHide() {
      return (
        this.$route.path.match(/\/product\//) ||
        (this.$route.name === 'BlogPage' && this.$route.params.slug)
      )
    },
    headlineExtraClass() {
      return this.$route.path.match(/\/product\//) ? ' headline-hidden' : ''
    },
  },
}
</script>

<style>
.headline-hidden .headline_text,
.headline-hidden .headline_aligner,
.headline-hidden.headline_inner:after {
  display: none !important;
}
/*.headline_outer .headline_inner:after*/
</style>
